<script>
export default {
  name: "IconBadge",
};
</script>

<template>
  <eg-b-badge pill class="icon-badge">
    <slot name="icon" />
    <slot class="light-grey-text" />
  </eg-b-badge>
</template>

<style scoped lang="scss">
.icon-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  background-color: #f9f9ff;
  font-weight: 400;
  padding: 0.25rem 0.63rem;
}
</style>
